import { Timestamp } from 'firebase/firestore';
import { useTime } from 'src/composables/time';

export const STAFF_LICENSE_STATUS = {
  STANDARD: 'standard',
  PREMIUM: 'premium',
  PREMIUM_FREE: 'premiumFree',
};

/**
 * Derives the staff license status (Standard / Premium / Premium (Free)) from a staff
 * profile's `status` and `licenseFreeUntil` fields.
 * @param {{ status?: string, licenseFreeUntil?: unknown }} staffMember
 * @returns {'standard' | 'premium' | 'premiumFree'}
 */
export const getStaffLicenseStatusValue = (staffMember) => {
  if (staffMember?.status !== 'active') {
    return STAFF_LICENSE_STATUS.STANDARD;
  }

  return staffMember?.licenseFreeUntil instanceof Timestamp
    ? STAFF_LICENSE_STATUS.PREMIUM_FREE
    : STAFF_LICENSE_STATUS.PREMIUM;
};

/**
 * @param {'standard' | 'premium' | 'premiumFree'} statusValue
 * @returns {string}
 */
export const getStaffLicenseStatusLabelKey = (statusValue) => {
  switch (statusValue) {
    case STAFF_LICENSE_STATUS.PREMIUM_FREE:
      return 'staff.status.premiumFree';
    case STAFF_LICENSE_STATUS.PREMIUM:
      return 'staff.status.active';
    case STAFF_LICENSE_STATUS.STANDARD:
    default:
      return 'staff.status.inactive';
  }
};

/**
 * @param {unknown} licenseFreeUntil
 * @returns {string}
 */
export const formatLicenseExpirationDate = (licenseFreeUntil) => {
  const { formatDate } = useTime();
  return (
    licenseFreeUntil instanceof Timestamp
      ? formatDate(licenseFreeUntil.toDate(), 'MM/dd/yyyy')
      : ''
  );
};
